export function getSessionStorage(key: string) {
  const sessionStorage = typeof window !== 'undefined' && window.sessionStorage
  if (sessionStorage) {
    const item = sessionStorage.getItem(key)
    return item ? JSON.parse(item) : null
  }
  return null
}

export function updateSessionStorage(key: string, value: any) {
  const sessionStorage = typeof window !== 'undefined' && window.sessionStorage
  if (sessionStorage) {
    const currentValue = sessionStorage.getItem(key)
    if (currentValue !== null) {
      const parsedValue = JSON.parse(currentValue)
      const updatedValue = { ...parsedValue, ...value }
      sessionStorage.setItem(key, JSON.stringify(updatedValue))
    } else {
      sessionStorage.setItem(key, JSON.stringify(value))
    }
  }
}
